// extracted by mini-css-extract-plugin
export default {"main":"ProductPage_main__ufanV","carouselHolder":"ProductPage_carouselHolder__DEdml","bodyContainer":"ProductPage_bodyContainer__FV7H7"};